import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Container, Sprite, Text } from '@pixi/react';
import { textureChangeFrame } from '../../../core/helpers/textureChangeFrame';
import { getGameImages } from '../../../core/helpers/getGameImages';

function Button({
  name,
  buttonText,
  textStyles,
  handleClickButton,
  children,
  additionalImages = {},
  x = 0,
  y = 0,
}) {
  const [isPressed, setIsPressed] = useState(false);
  const textureRef = useRef();
  const { buttonBgHovered, buttonBgDefault, buttonBgPressed } = useMemo(() => {
    return Object.keys(additionalImages).length ? additionalImages : getGameImages();
  }, [additionalImages]);

  const handlePlayButtonPointerOver = useCallback(() => {
    if (!isPressed) textureChangeFrame(textureRef.current, buttonBgHovered);
  }, [isPressed, buttonBgHovered, textureRef]);

  const handlePlayButtonPointerOut = useCallback(
    () => textureChangeFrame(textureRef.current, buttonBgDefault),
    [buttonBgDefault, textureRef]
  );

  const handlePlayButtonPointerDown = useCallback(() => {
    setIsPressed(true);
    textureChangeFrame(textureRef.current, buttonBgPressed);
  }, [buttonBgPressed, textureRef]);

  const handlePlayButtonPointerUp = useCallback(
    (e) => {
      e.stopPropagation();
      setIsPressed(false);
      textureChangeFrame(textureRef.current, buttonBgDefault);
      handleClickButton();
    },
    [handleClickButton, buttonBgDefault, textureRef]
  );

  return (
    <Container
      x={x}
      y={y}
      name={name}
      interactive
      cursor='pointer'
      pointermove={handlePlayButtonPointerOver}
      pointerout={handlePlayButtonPointerOut}
      pointerdown={handlePlayButtonPointerDown}
      pointerup={handlePlayButtonPointerUp}
    >
      <Sprite anchor={0.5} texture={buttonBgDefault} ref={textureRef} />
      <Text text={buttonText} style={textStyles} anchor={0.5} resolution={2} />
      {children}
    </Container>
  );
}

export default Button;
